import { type To } from "react-router-dom";
import { SourcingEventStatus } from "../../../autogen/bff-api";
import { urls } from "../../../urls";

// Drafts are still editable, so jump into the buyer wizard. Anything past draft is read-only —
// send the user to the V2 details view rather than the now-locked editor.
export const procurementEntryHref = (status: SourcingEventStatus, id: string): To =>
  status === SourcingEventStatus.Draft
    ? urls.publicEvents.edit.go(id).info
    : urls.v2.sourcingEvents.view.go(id);
